import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbDummyAuthStrategy } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { of as observableOf } from 'rxjs';

import { throwIfAlreadyLoaded } from './module-import-guard';
import {
  LayoutService,
  RegexService,
} from './utils';
import { LookupService } from './services/lookup.service';
import { HttpinterceptorService } from './services/httpinterceptor';
import { UrlProviderService } from './services/local/url-provider.service';
import { AppTypeFormService } from './services/local/app-type-form.service';
import { AddressFormService } from './services/local/address-form.service';
import { ChildFormsService } from './services/local/child-forms.service';
import { DelegateInfoService } from './services/local/delegate-info.service';
import { UsageTypesServiceService } from './services/local/usage-types-service.service';
import { ErpTypesFormService } from './services/local/erp-types-form.service';
import { SettingsService } from './services/local/settings.service';
import { PersonInfoService } from './services/local/person-info.service';
import { FileDownloaderService } from './services/local/file-downloader.service';
import { CustomerService } from './services/customer.service';
import { OnlineApplicationService } from './services/online-application.service';
import { NumberOnlyDirective } from '../@theme/directives/NumberOnly.directive';
import { UrlParamService } from './services/local/url-param.service';
import { LoadingService } from './services/local/loading.service';
import { CustomerApplicationBinderService } from './services/local/customer-application-binder.service';
import { NbDateFnsDateService } from '@nebular/date-fns';
import { CommonDataSharedService } from './services/common-data-shared.service';
import { LoginGuard } from './guards/login.guard';
import { AesService } from './services/local/aes.service';

const socialLinks = [
  {
    url: 'https://github.com/akveo/nebular',
    target: '_blank',
    icon: 'github',
  },
  {
    url: 'https://www.facebook.com/akveo/',
    target: '_blank',
    icon: 'facebook',
  },
  {
    url: 'https://twitter.com/akveo_inc',
    target: '_blank',
    icon: 'twitter',
  },
];

const DATA_SERVICES = [
  HttpinterceptorService,
  UrlProviderService,
  LookupService,
  AppTypeFormService,
  AddressFormService,
  ChildFormsService,
  DelegateInfoService,
  UsageTypesServiceService,
  ErpTypesFormService,
  SettingsService,
  PersonInfoService,
  FileDownloaderService,
  CustomerService,
  OnlineApplicationService,
  UrlParamService,
  LoadingService,
  CustomerApplicationBinderService,
  CommonDataSharedService,
  NbDateFnsDateService,
  LoginGuard,
  AesService
  
];

export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf('guest');
  }
}

export const NB_CORE_PROVIDERS = [
  ...DATA_SERVICES,
  ...NbAuthModule.forRoot({

    strategies: [
      NbDummyAuthStrategy.setup({
        name: 'email',
        delay: 3000,
      }),
    ],
    forms: {
      login: {
        socialLinks: socialLinks,
      },
      register: {
        socialLinks: socialLinks,
      },
    },
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: '*',
      },
      user: {
        parent: 'guest',
        create: '*',
        edit: '*',
        remove: '*',
      },
    },
  }).providers,

  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  },
  LayoutService,
  RegexService
];

const CORE_DIRECTIVES = [
  NumberOnlyDirective
];


@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
